// chat-ui/src/auth/AuthModal.js
import React, { useState } from 'react';
import { registerUser, loginUser } from './authService';
// import QRCodeDisplay from '../components/QRCodeDisplay'; // Keeping this commented as it's not used in the current JSX

const AuthModal = ({ onClose }) => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (isSignUp) {
        await registerUser(email, password);
      } else {
        await loginUser(email, password);
      }
      onClose(); // Close modal on success
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="modal-overlay"> {/* Changed from auth-modal-overlay */}
      <div className="modal-content"> {/* Changed from auth-modal */}
        <button className="modal-close-button" onClick={onClose}> {/* Changed from close-modal, updated content */}
          &times;
        </button>
        <h2>{isSignUp ? 'Sign Up' : 'Sign In'}</h2>
        {error && <p className="modal-error">{error}</p>} {/* Changed from error-message */}

        <form className="modal-form" onSubmit={handleSubmit}> {/* Added modal-form wrapper */}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">{isSignUp ? 'Sign Up' : 'Sign In'}</button>
        </form> {/* End modal-form wrapper */}

        <button className="toggle-auth-mode" onClick={() => setIsSignUp(!isSignUp)}> {/* Changed from p.toggle-auth */}
          {isSignUp ? 'Already have an account? Sign In' : 'Need an account? Sign Up'}
        </button>

<div className="modal-divider"></div> {/* Added the horizontal divider */}

<div className="user-tiers"> {/* Changed from tier-info */}
  <strong>User Tiers:</strong>
  <p className="user-tier-item"> {/* Added user-tier-item class */}
    <strong>Sīla:</strong> Free users, 5 queries/day.<br />
    <strong>Samādhi:</strong> Paid ($7/month), 100 queries/day.<br />
    <strong>Paññā:</strong> Paid ($30+, dāna), 1000 queries/day.<br />
    Upgrade your tier by contacting gautama.dhamma@gmail.com
  </p>
  {/* Conditional rendering for QR code, typically for sign-up or upgrade flows */}
  {isSignUp && ( // You might want different logic here based on your tier upgrade process
    <img src="/path/to/your/qr_code.png" alt="Upgrade QR Code" className="qr-code" />
    // If you use the QRCodeDisplay component:
    // <QRCodeDisplay value="https://gautamadhamma.org" size={120} className="qr-code" />
  )}
</div> 

      </div>
    </div>
  );
};

export default AuthModal;